// extracted by mini-css-extract-plugin
module.exports = {"wrap":"CwPodElement-wrap","label":"CwPodElement-label","required":"CwPodElement-required","labelinvalid":"CwPodElement-labelinvalid","labelblue":"CwPodElement-labelblue"};